import React from 'react';
import { App, routes } from '@assets/spa/App';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import client from '@gql/client';
const rootEl = document.getElementById('root');
const i18n = window.wp.i18n;
const router = createBrowserRouter(routes);
const isHydration = rootEl.dataset.hydration === 'true';
if (isHydration) {
    hydrateRoot(rootEl, React.createElement(App, Object.assign({}, { i18n, client }),
        React.createElement(RouterProvider, { router: router })));
}
else {
    const root = createRoot(rootEl);
    root.render(React.createElement(App, Object.assign({}, { i18n, client }),
        React.createElement(RouterProvider, { router: router })));
}
